const getDefaultState = () => {
  return {
    userCS: {},
    userCSNotFound: false,
    userCSError: null,
    loading: false,
    consumerUnits: [],
    consumerUnitsOpened: [],
    consumerUnit: {},
    billings: [],
    billing: {},
    status: "empty",
    history: [],
    activeBilling: 0,
    loadingBillingCS: false,
    observation: {},
    observations: [],
    task: {},
    tasks: [],
    agents: [],
    activities: [],
    filter: {
      email: "",
      phone: "",
      cpf: "",
      installation_number: "",
    },
    negativations: [],
    negativation: null,
    overdue: false,
    cards: [],
    activeCards: 0,
    loadingCards: false,
    contracts: [],
    accountBalanceHistory: [],
    referrals: [],
    specialBillings: [],
    provisionedBillings: [],
    documents: [],
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
